module.exports = __webpack_public_path__ + "img/onvego.2cb3174e.svg";